import { observer, pr, React, RouteComponentProps, ui } from "aaa";
import { pushRoute } from "stores/RouterFunctions";
import { ISigningResponse } from "types/signing";
import { SigningComponent } from "../signing/views/SigningComponent";
import { AliasStore } from "./AliasStore";

type IProps = RouteComponentProps<{}> & {
    store: AliasStore;
};

@observer
export class AliasDeleteUsernameSigning extends React.Component<IProps, {}> {
    render() {
        return (
            <SigningComponent
                signingInfo={this.props.store.signInfo}
                content={
                    <div>
                        <pr.SigningLabelContainer>
                            <pr.SigningLabelTitle>{ui.__("signing.action.label")}</pr.SigningLabelTitle>
                            <pr.SigningLabel>
                                {ui.__("sidentitySettings.deleteUsername.summary")}
                            </pr.SigningLabel>
                            <br />

                            <pr.SigningLabelTitle>{ui.__("common.fees")}</pr.SigningLabelTitle>
                            <pr.SigningLabel>{ui.__("common.freeOfCharge")}</pr.SigningLabel>

                        </pr.SigningLabelContainer>
                    </div>
                }

                onSuccess={(response: ISigningResponse) => {
                    this.props.store.signingAlias = undefined;
                    pushRoute("delete-username-success");
                }}

                onRetry={async () => {
                    await this.props.store.deleteAlias();
                }}
            />
        );
    }
}



// WEBPACK FOOTER //
// ./src/components/alias/AliasDeleteUsernameSigning.tsx